import useStore from "stores/index";
import { getSupportContactDetails } from "stores/classwizeConfigStore";
import React, { useEffect, useState } from "react";
import shallow from "zustand/shallow";

const Chatbot = () => {
	const [supportContactDetails, updateSupportContactDetails] = useState(getSupportContactDetails(useStore.getState()));

	useEffect(() => {
		const unsubSupportContactDetails = useStore.subscribe(
			(state) => [state.classwizeConfig.data],
			() => updateSupportContactDetails(getSupportContactDetails(useStore.getState())),
			shallow
		);

		const deviceId = localStorage.getItem("DEVICE");
		const chatbotId = supportContactDetails.support_chatbot_id;
		const supportContactName = supportContactDetails.support_contact_name;
		const supportContactEmail = supportContactDetails.support_contact_email;

		if (supportContactDetails.enable_support_chatbot && deviceId && chatbotId && supportContactName && supportContactEmail) {
			window.__be = window.__be || {};
			window.__be.id = chatbotId;

			window.BE_API = window.BE_API || {};
			window.BE_API.onLoad = () => {
				/* eslint-disable camelcase */
				window.BE_API.setUserAttributes({
					device_id: deviceId,
					district_contact_name: supportContactName,
					district_contact_email: supportContactEmail,
				});
				/* eslint-enable camelcase */
			};

			(function () {
				const be = document.createElement("script");
				be.type = "text/javascript";
				be.async = true;
				be.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.chatbot.com/widget/plugin.js";
				const s = document.getElementsByTagName("script")[0];
				s.parentNode.insertBefore(be, s);
			})();
		}

		return () => {
			unsubSupportContactDetails();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <div id="chatbot" />;
};

export default Chatbot;
